import { baseApi } from 'shared/api/baseApi'
import { PHASES_TAG } from 'shared/api/tags'

import type { CompetitionResponseData } from '../../competitions/model/types'
import { transformPhaseToReq } from '../../competitions/model/transformations/transformPhaseToReq'
import type { PhaseFormType, PhaseType } from '../model/types'

export const phaseApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        editPhase: build.mutation<
            Array<CompetitionResponseData>,
            {
                params: { competitionId: string; phaseId: string }
                body: { name: string }
            }
        >({
            query: ({ params, body }) => ({
                url: `competitions/${params.competitionId}/phases/${params.phaseId}`,
                method: 'PATCH',
                body: body,
            }),
            invalidatesTags: [PHASES_TAG],
        }),

        getPhases: build.query<PhaseType[], { competitionIds: string }>({
            query: ({ competitionIds }) => ({
                url: `competition/${competitionIds}/phases`,
                method: 'GET',
            }),

            providesTags: [PHASES_TAG],
        }),

        newPhase: build.mutation<
            CompetitionResponseData,
            {
                params: { competitionId: string }
                body: PhaseFormType
            }
        >({
            query: ({ params, body }) => ({
                url: `competitions/${params.competitionId}/phases`,
                method: 'POST',
                body: transformPhaseToReq(body),
            }),
            invalidatesTags: [PHASES_TAG],
        }),

        deletePhase: build.mutation<
            CompetitionResponseData,
            {
                params: { competitionId: string; phaseId: string }
            }
        >({
            query: ({ params }) => ({
                url: `competitions/${params.competitionId}/phases/${params.phaseId}`,
                method: 'DELETE',
            }),
            invalidatesTags: [PHASES_TAG],
        }),
    }),
})

export const {
    useEditPhaseMutation,
    useGetPhasesQuery,
    useLazyGetPhasesQuery,
    useNewPhaseMutation,
    useDeletePhaseMutation,
} = phaseApi
